import React, { useState, useContext, useEffect } from 'react';
import { I as ItemTabs } from './ItemTabs-PRQx9xWO.js';
import { M as MD_WIDTH } from './breakpoints-X1SKRYyW.js';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-YC9H491Y.js';
import { CoreContext } from './context/index.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import 'cookies-next';
import './index-zNO-4REJ.js';
import 'next/router';
import 'notistack';
import 'next-i18next';
import useWindowSize from './hooks/useWindowSize.js';
import 'lodash/get';
import './product-_pRduMz7.js';
import './helpers-kA_hdoOI.js';
import 'lodash';
import { I as ItemsAccordion } from './ItemsAccordion-b0XndCSS.js';
import { T as TabNames } from './helper-qZTqmbEO.js';
import { useTranslation } from 'react-i18next';

const ItemCopy = ({ description, information, productTab3, productTab4, accordionExtraContent, isBedOrMattress, }) => {
    const [activeTab, setActiveTab] = useState(TabNames.Description);
    const { data: { siteConfig: { product: { itemCopyDesktop = 'tabs', itemCopyMobile = 'accordion', enableAccorRewardsTab = false, enableShippingReturnsTab = false, } = {}, }, }, } = useContext(CoreContext);
    const { t } = useTranslation('', { keyPrefix: '' });
    const tabsArray = [
        {
            type: TabNames.Description,
            html: description,
        },
        {
            type: TabNames.Details,
            html: information,
        },
    ];
    // We check for tab 3 and tab 4 that will need to come as props from the product once those attributes are available on the BE
    if (!!productTab3 && productTab3 !== '') {
        tabsArray.push({
            type: TabNames.ProductTab3,
            html: productTab3,
        });
    }
    // TODO: This will render as "tab-5" and probably needs a cleaner implementation in general
    if (enableShippingReturnsTab) {
        tabsArray.push({
            type: TabNames.ShippingReturns,
            html: isBedOrMattress ? t('$common.shippingReturnsBedTab') : t('$common.shippingReturnsTab'),
        });
    }
    // TODO: This will render as "tab-6" and probably needs a cleaner implementation in general
    if (enableAccorRewardsTab) {
        tabsArray.push({
            type: TabNames.AccorRewards,
            html: t('$accorCommon.rewardsTabDescription'),
        });
    }
    if (!!productTab4 && productTab4 !== '') {
        tabsArray.push({
            type: TabNames.ProductTab4,
            html: productTab4,
        });
    }
    const windowSize = useWindowSize();
    const isMobile = Boolean(windowSize.width) && windowSize.width <= MD_WIDTH;
    const renderTabs = isMobile ? itemCopyMobile === 'tabs' : itemCopyDesktop === 'tabs';
    // Reset Active Tab when switching to another product
    useEffect(() => {
        setActiveTab(TabNames.Description);
    }, [description]);
    return renderTabs ? (React.createElement(ItemTabs, { items: tabsArray, activeTab: activeTab, setActiveTab: setActiveTab })) : (React.createElement(ItemsAccordion, { items: tabsArray, activeTab: activeTab, setActiveTab: setActiveTab, accordionExtraContent: !(itemCopyDesktop === 'tabs') && accordionExtraContent }));
};

export { ItemCopy as I };
//# sourceMappingURL=ItemCopy-z1KHutzo.js.map
